import { useRouteError } from 'react-router-dom';

export const BubbleError = () => {
  const error = useRouteError();

  if (error) throw error;

  return null;
};
